<template>
  <div class="w-full">
    <NText variant="caption1" weight="medium">
      {{
        t('option.freezeConfirmDialog', {
          type: symbol.isFreeze ? t('option.freeze') : t('option.unFreeze'),
          symbolName: symbol.name,
        })
      }}
    </NText>

    <div class="flex items-center justify-center w-full mt-6">
      <NButton
        class="ml-3 flex-1"
        color="gray"
        variant="flat"
        @click="remove()"
      >
        {{ t('common.cancel') }}
      </NButton>

      <NButton
        color="red"
        class="mr-3 flex-1"
        :loading="loading"
        :disabled="loading"
        @click="emit('delete', symbol.requestId)"
      >
        {{ t('common.cancelRequest') }}
      </NButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog } from '@negar/core';
import { FrozenHistoryItem } from '@libs/api-reference';

type TConfirmDeleteFreezeDialogEmits = {
  (e: 'delete', isin: string): void;
};

type TConfirmDeleteFreezeDialogProps = {
  symbol: FrozenHistoryItem;
  loading: boolean;
};

const emit = defineEmits<TConfirmDeleteFreezeDialogEmits>();

defineProps<TConfirmDeleteFreezeDialogProps>();

const { remove } = useDialog();

const { t } = useI18n();
</script>
